/**
 * Empty State Component
 *
 * Displays when QuickBooks is not connected.
 * Features:
 * - Clear messaging
 * - Inline QuickBooks connection interface
 * - No navigation required
 */

import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { CloudOff } from '@mui/icons-material';
import ConnectionStatus from '../../features/quickbooks/components/ConnectionStatus';

interface EmptyStateProps {
  /** Studio ID for QuickBooks connection */
  studioId: string;
}

/**
 * Empty State component for when QuickBooks is not connected
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ studioId }) => (
  <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        mb: 4,
      }}
    >
      <CloudOff
        sx={{
          fontSize: 80,
          color: 'text.secondary',
          mb: 2,
        }}
      />
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 600,
          color: 'text.primary',
        }}
      >
        QuickBooks Not Connected
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          maxWidth: 600,
          mb: 3,
        }}
      >
        Connect your QuickBooks Online account to view financial insights and
        analytics. Your connection will also enable QuickBooks Sales Receipts
        upload functionality.
      </Typography>
    </Box>

    {/* Inline QuickBooks Connection Interface */}
    <ConnectionStatus studioId={studioId} />
  </Container>
);

export default EmptyState;
